import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { botTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

const EDIT_BOT_PAGE_TOAST = 'edit-bot-page';

export const editBotPage: botTypes.EditPage = async (data) => {
  const { _id, ...dataWithoutId } = data;
  return axios.patch(`/bot/pages/${_id}`, { data: dataWithoutId });
};

type EditBotPageOptions = {
  config?: MutationConfig<typeof editBotPage>;
};

export function useEditBotPage({ config = {} }: EditBotPageOptions) {
  return useMutation({
    ...config,
    onMutate: (variables) => {
      toasts.loadingToast.loading(EDIT_BOT_PAGE_TOAST, 'Editing page...');
      return config.onMutate?.(variables);
    },
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['bot-pages']);
      toasts.loadingToast.success(EDIT_BOT_PAGE_TOAST, 'Page edited successfully');
      config.onSuccess?.(...args);
    },
    onError: (error: AxiosError<{ error: string }>, variables, context) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error(EDIT_BOT_PAGE_TOAST, serverMessage);
      config.onError?.(error, variables, context);
    },
    mutationFn: editBotPage,
  });
}
